var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container search" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 text-right" }, [
              _c("a", { attrs: { href: _vm.$laravelRoute("manage") } }, [
                _vm._v("Back To Admin Panel")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.onSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c("messages", { attrs: { messages: _vm.messages } }),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12 container-search" }, [
                  _c(
                    "div",
                    { staticClass: "form-row mt-2" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-2",
                          attrs: {
                            label: "Enabled",
                            "label-for": "enabled",
                            state: _vm.fieldState("enabled"),
                            "invalid-feedback": _vm.invalidField("enabled")
                          }
                        },
                        [
                          _c("b-form-checkbox", {
                            attrs: { id: "enabled" },
                            model: {
                              value: _vm.setting.enabled,
                              callback: function($$v) {
                                _vm.$set(_vm.setting, "enabled", $$v)
                              },
                              expression: "setting.enabled"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-row" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "col-md-6",
                          attrs: {
                            label: "Last Updated",
                            "label-for": "last_updated",
                            state: _vm.fieldState("last_updated"),
                            "invalid-feedback": _vm.invalidField("last_updated")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              placeholder: "Last updated"
                            },
                            model: {
                              value: _vm.setting.value.last_updated,
                              callback: function($$v) {
                                _vm.$set(_vm.setting.value, "last_updated", $$v)
                              },
                              expression: "setting.value.last_updated"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "form-group col-md-6" },
                    [
                      _c(
                        "b-btn",
                        { staticClass: "btn", attrs: { type: "submit" } },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h2", [_vm._v("Market Research Settings")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36280f52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36280f52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SiteSettings/TermsAndConditions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-36280f52","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SiteSettings/TermsAndConditions.vue
// module chunks = 0